module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-arrow-up-f2cbc128.svg";